import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { Impression as BedrockImpression } from '@nerdwallet/analytics/react/impression';
import { getLogger } from '@nerdwallet/logging';
import rootLogger from '~/client/lib/logger-utils';

import { trackSegmentPageEvent } from '../lib/segment-analytics';

const logger = getLogger('RouteContainer', rootLogger);

const getImpressionParams = (analyticsName, pathname, matchParams) => {
  // Bedrock event
  if (!analyticsName) {
    logger.error(
      `Warning: No analyticsName found for ${pathname}, page_impression will not fire.`
    );
    return {};
  }

  const params = {
    entityName: analyticsName,
    eventType: 'page_impression',
    payload: {
      display_mode: 'standard',
    },
  };

  // Fire a subclassed page_impression for department and job pages
  if (analyticsName === 'department_page') {
    params.eventType = 'department_page_impression';
    params.payload.additional_attributes = {
      department_name: matchParams.slug,
    };
  } else if (analyticsName === 'job_page') {
    params.eventType = 'job_page_impression';
    params.payload.additional_attributes = {
      job_id: parseInt(matchParams.id, 10),
    };
  }

  return params;
};

class Container extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { analyticsName, segmentPageName, location, match, children } =
      this.props;
    const impressionParams = getImpressionParams(
      analyticsName,
      location.pathname,
      match.params
    );

    if (segmentPageName) {
      trackSegmentPageEvent(segmentPageName, match?.params);
    }

    return (
      <BedrockImpression {...impressionParams}>
        <div className="route-container">{children}</div>
      </BedrockImpression>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Container.displayName = 'RouteContainer';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Container.propTypes = {
  analyticsName: PropTypes.string,
  segmentPageName: PropTypes.string,
  analyticsClass: PropTypes.string,
  location: PropTypes.object,
  match: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
};

export default Container;
